import { AsyncPipe } from '@angular/common';
import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgbDateStruct, NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { PortfolioReportFacade } from '@zero/self-service/domain';
import { TransactionAuthorizationComponent } from '@zero/shared/ui-web-components';
import { ButtonComponent } from '@zero/shared/ui-web-design-system';
import { TransactionAuthorizationResult } from '@zero/shared/util-models';
import { AuthService } from '@zero/shared/util-web-app-services';
import { TerminateDepotComponent } from '../terminate-depot/terminate-depot.component';

@Component({
  selector: 'self-service-portfolio-report',
  templateUrl: './portfolio-report.component.html',
  standalone: true,
  imports: [
    NgbDatepickerModule,
    FormsModule,
    TransactionAuthorizationComponent,
    AsyncPipe,
    TranslocoPipe,
    ButtonComponent,
    TerminateDepotComponent,
  ],
})
export class PortfolioReportComponent implements OnInit, OnDestroy {
  public readonly portfolioReportFacade = inject(PortfolioReportFacade);
  public readonly authService = inject(AuthService);
  public maxDate: NgbDateStruct;
  public formOpened = false;

  ngOnInit(): void {
    const today = new Date();
    this.maxDate = {
      year: today.getFullYear(),
      month: today.getMonth() + 1,
      day: today.getDate(),
    };
  }

  ngOnDestroy(): void {
    this.formOpened = false;
    this.portfolioReportFacade.dataToAuthorize = null;
    this.portfolioReportFacade.initiated = false;
  }

  public requestReport() {
    this.portfolioReportFacade.requestReport();
  }

  public toggleForm() {
    this.formOpened = !this.formOpened;
  }

  public handleAuthenticationResult(result: TransactionAuthorizationResult) {
    this.portfolioReportFacade.handleAuthenticationResult(result);
    if (result.reason === 'CanceledByUser') {
      this.formOpened = false;
    }
  }
}
